import React from 'react'
import styled from 'styled-components'

const Link = styled.a `
  position: absolute;
  right: 0px;
  bottom: 40px;
  display: inline-block;
  border-bottom: 1px solid #393939;
  width: 225px;
  text-align: right;
  color: #393939;
  padding-bottom: 15px;
  padding-right: 30px;

  @media screen and (max-width: 640px) {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 35px;
  }
`

const Discover = styled.span.attrs({ children: 'Discover' }) `
  display: inline-block;
  font-family: 'Georgia';
  font-style: italic;
  font-size: 13px;
  letter-spacing: 3px;
`

const More = styled.span.attrs({ children: 'More' }) `
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  margin-left: 10px;
  letter-spacing: 3px;
`

const DiscoverMore = ({ href }) => (
  <Link href="/pdfs/portfolio.pdf" target="_blank">
    <Discover /><More />
  </Link>
)

export { DiscoverMore }
